export default "__VITE_ASSET__pvkx5Kjm__"